/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsCustomType from '@jira/spa-apps__servicedesk-reports-custom/src/KbRequestsReportsApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReportsCustom: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskReportsCustomType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-custom", jiraSpaEntry: "async-servicedesk-reports-custom" */ '@jira/spa-apps__servicedesk-reports-custom/src/KbRequestsReportsApp.tsx'
		),
	),
);

const AsyncServicedeskReportsCustom = ({ match }: RouteContext): React.JSX.Element => {
	const reportType = match.params.reportType || '';
	return (
		<LazyPage
			Page={LazyServicedeskReportsCustom}
			pageId={`spa-apps/servicedesk/reports/${reportType}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReportsCustom;
